<table>
  <thead>
    <tr>
      <th scope="colgroup" colspan="2">User right</th>
      <th scope="colgroup" colspan="4">Right (single)</th>
      <th scope="colgroup" colspan="3">Right (multiple)</th>
    </tr>
    <colgroup>
      <col span="2" />
      <col span="4" />
      <col span="3" />
    </colgroup>
    <tr>
      <th scope="col">Name</th>
      <th scope="col">Target</th>
      <th scope="col">Back, Write</th>
      <th scope="col">Back, Read</th>
      <th scope="col">Front, Write</th>
      <th scope="col">Front, Read</th>
      <th scope="col">Back</th>
      <th scope="col">Front</th>
      <th scope="col">All</th>
    </tr>
  </thead>
  <tr *ngFor="let rightGroupUi of userRightsGroupUis">

    <th scope="row">{{rightGroupUi.userRightName}}</th>
    <td>{{rightGroupUi.userRightTarget}}</td>

    <td class="right-column"><input type="checkbox" (change)="rightGroupUi.backWriteChanged()"
                                    [(ngModel)]="rightGroupUi.backWrite"></td>
    <td class="right-column"><input type="checkbox" (change)="rightGroupUi.backReadChanged()"
                                    [(ngModel)]="rightGroupUi.backRead"></td>
    <td class="right-column"><input type="checkbox" (change)="rightGroupUi.frontWriteChanged()"
                                    [(ngModel)]="rightGroupUi.frontWrite"></td>
    <td class="right-column"><input type="checkbox" (change)="rightGroupUi.frontReadChanged()"
                                    [(ngModel)]="rightGroupUi.frontRead"></td>
    <td class="right-column"><input type="checkbox"
                                    [(ngModel)]="rightGroupUi.isAllBackSelected"></td>
    <td class="right-column"><input type="checkbox"
                                    [(ngModel)]="rightGroupUi.isAllFrontSelected"></td>
    <td class="right-column"><input type="checkbox"
                                    [(ngModel)]="rightGroupUi.isAllSelected"></td>

  </tr>
</table>
